"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var Observable_1 = require("rxjs/Observable");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var operators_1 = require("rxjs/operators");
var type_configuration_service_1 = require("../api/type-configuration.service");
var of_1 = require("rxjs/observable/of");
var static_method_1 = require("../../utils/static-method");
var url_and_query_params_1 = require("../../utils/url-and-query-params");
// tslint:disable:max-line-length
var DefaultModelDecoratorService = /** @class */ (function () {
    function DefaultModelDecoratorService(deService, classifierService, currentLanguageProvider, portfolioService, kbService, dePermissionService, typeConfigurationService) {
        this.deService = deService;
        this.classifierService = classifierService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.portfolioService = portfolioService;
        this.kbService = kbService;
        this.dePermissionService = dePermissionService;
        this.typeConfigurationService = typeConfigurationService;
    }
    DefaultModelDecoratorService_1 = DefaultModelDecoratorService;
    DefaultModelDecoratorService.fetchTypeIdentifier = function (config, params, queryParams, transientFields) {
        if (config) {
            var fromTransientFields = transientFields && transientFields[config.field];
            var fromQueryParams = queryParams && queryParams[url_and_query_params_1.UrlAndQueryParams.typeId];
            var fromParams = params && params[url_and_query_params_1.UrlAndQueryParams.typeId];
            return fromTransientFields || fromQueryParams || fromParams;
        }
        return null;
    };
    DefaultModelDecoratorService.fetchSubTypeIdentifier = function (config, params, queryParams, transientFields) {
        if (config) {
            var fromTransientFields = transientFields && transientFields[config.field];
            var fromQueryParams = queryParams && queryParams[url_and_query_params_1.UrlAndQueryParams.subTypeId];
            var fromParams = params && params[url_and_query_params_1.UrlAndQueryParams.subTypeId];
            return fromTransientFields || fromQueryParams || fromParams;
        }
        return null;
    };
    DefaultModelDecoratorService.fetchPropertyByConstantKey = function (params, queryParams, transientFields, key) {
        var fromTransientFields = transientFields && transientFields[key];
        var fromQueryParams = queryParams && queryParams[key];
        var fromParams = params && params[key];
        return fromTransientFields || fromQueryParams || fromParams;
    };
    DefaultModelDecoratorService.prototype.decorate = function (category, formId, inDrawer, params, queryParams, transientFields, entity) {
        var _this = this;
        // when entity create form opened through duplication of another entity then automatically filling entity field values
        if (queryParams[url_and_query_params_1.UrlAndQueryParams.isAutofill]) {
            return this.duplicateEntity(entity, category, +queryParams[url_and_query_params_1.UrlAndQueryParams.duplicateEntityId]);
        }
        return of_1.of(entity).pipe(operators_1.switchMap(function (value) { return _this.initParentRootIdentifier(value, category, params, queryParams, transientFields); }), operators_1.switchMap(function (value) { return _this.initTypeProperties(value, category, params, queryParams, transientFields); }));
    };
    DefaultModelDecoratorService.prototype.duplicateEntity = function (entity, categoryName, duplicatedEntityId) {
        var _this = this;
        var duplicateEntity$ = this.deService.loadEntityByInstanceId(categoryName, duplicatedEntityId);
        var metaFields$ = this.kbService.getMetaFields(categoryName);
        var permissions$ = this.dePermissionService.getCategoryDePermissionsByInstance(categoryName, -1);
        return Observable_1.Observable.combineLatest(duplicateEntity$, metaFields$, permissions$).pipe(operators_1.switchMap(function (res) {
            var duplicateEntity = res[0];
            var metaFields = res[1];
            var permissions = res[2];
            var assignments$ = metaFields
                .filter(function (metaField) { return !static_method_1.isSystemField(metaField); })
                .filter(function (metaField) { return permissions.addableFields.find(function (field) { return field === metaField.getSystemName(); }); })
                .map(function (metaField) {
                if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY) {
                    return _this.kbService.getMetaFields(metaField.getCompoundCategorySystemName()).pipe(operators_1.tap(function (subCategoryFields) {
                        if (!subCategoryFields.some(function (field) { return field.getType() === idm_kb_service_client_js_1.MetaFieldType.DOCUMENT; })) {
                            entity.getProperty(metaField.getSystemName()).value = duplicateEntity.getProperty(metaField.getSystemName()).value;
                        }
                    }));
                }
                else {
                    return Observable_1.Observable.of([]).pipe(operators_1.tap(function () { return entity.getProperty(metaField.getSystemName()).value = duplicateEntity.getProperty(metaField.getSystemName()).value; }));
                }
            });
            return assignments$.length ? Observable_1.Observable.zip.apply(Observable_1.Observable, assignments$).pipe(operators_1.map(function () { return entity; })) : Observable_1.Observable.of(entity);
        }));
    };
    DefaultModelDecoratorService.prototype.initTypeProperties = function (entity, category, params, queryParams, transientFields) {
        var _this = this;
        return this.typeConfigurationService.getTypedCategoryProperties(category).pipe(operators_1.concatMap(function (typeConfigs) {
            if (typeConfigs) {
                var typeId = DefaultModelDecoratorService_1.fetchTypeIdentifier(typeConfigs.type, params, queryParams, transientFields);
                var subTypeId_1 = DefaultModelDecoratorService_1.fetchSubTypeIdentifier(typeConfigs.subType, params, queryParams, transientFields);
                var typeClassifiers$ = [];
                if (typeId) {
                    typeClassifiers$.push(_this.classifierService.loadClassifier(typeConfigs.type.category, typeId));
                    if (subTypeId_1) {
                        typeClassifiers$.push(_this.classifierService.loadClassifier(typeConfigs.subType.category, subTypeId_1));
                    }
                }
                if (typeClassifiers$.length) {
                    return Observable_1.Observable.zip.apply(Observable_1.Observable, typeClassifiers$).map(function (_a) {
                        var typeClassifier = _a[0], subTypeClassifier = _a[1];
                        // set type value
                        entity.getProperty(typeConfigs.type.field).value = typeClassifier;
                        if (subTypeId_1) {
                            // set sub-type value
                            entity.getProperty(typeConfigs.subType.field).value = subTypeClassifier;
                        }
                        return entity;
                    });
                }
            }
            return of_1.of(entity);
        }));
    };
    DefaultModelDecoratorService.prototype.initParentRootIdentifier = function (entity, category, params, queryParams, transientFields) {
        var _this = this;
        var rootEntityIdentifier = DefaultModelDecoratorService_1.fetchPropertyByConstantKey(params, queryParams, transientFields, url_and_query_params_1.UrlAndQueryParams.rootEntityId);
        if (rootEntityIdentifier) {
            return this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(category)).pipe(operators_1.switchMap(function (currentCategory) {
                if (!currentCategory.getIsRoot) {
                    return _this.kbService.getMetaFields(category).pipe(operators_1.switchMap(function (fields) {
                        var parentMetaField = fields.find(function (value) { return value.getType() === idm_kb_service_client_js_1.MetaFieldType.PARENT; });
                        if (parentMetaField) {
                            entity.getProperty(parentMetaField.getSystemName()).value = rootEntityIdentifier;
                        }
                        else {
                            // handle case when root category is not defined as a parent in child categories
                            // todo: just to cover existing incorrect KB structure, will be removed after in further releases
                            var rootCategoryId_1 = DefaultModelDecoratorService_1.fetchPropertyByConstantKey(params, queryParams, transientFields, url_and_query_params_1.UrlAndQueryParams.rootCategoryId);
                            if (rootCategoryId_1) {
                                var rootMainEntityMetaField_1 = fields.find(function (value) { return value.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY && value.getCompoundCategorySystemName() === rootCategoryId_1; });
                                if (rootMainEntityMetaField_1) {
                                    return _this.kbService.getInstanceMetaField(rootMainEntityMetaField_1.getCompoundCategorySystemName()).pipe(operators_1.map(function (instanceMetaField) {
                                        entity.getProperty(rootMainEntityMetaField_1.getSystemName()).value = static_method_1.constructMainEntity(instanceMetaField.getSystemName(), rootEntityIdentifier);
                                        return entity;
                                    }));
                                }
                            }
                            else {
                                return _this.kbService.getMainEntityMetaCategories().pipe(operators_1.map(function (categories) { return Array.from(categories).filter(function (value) { return value.getIsRoot; }); }), operators_1.map(function (rootCategories) { return rootCategories.map(function (value) { return value.getSystemName(); }); }), operators_1.switchMap(function (rootCategories) {
                                    var lookupToRootField = fields.find(function (value) { return value.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY &&
                                        rootCategories.includes(value.getCompoundCategorySystemName()); });
                                    if (lookupToRootField) {
                                        return _this.kbService.getInstanceMetaField(lookupToRootField.getCompoundCategorySystemName()).pipe(operators_1.map(function (instanceMetaField) {
                                            entity.getProperty(lookupToRootField.getSystemName()).value = static_method_1.constructMainEntity(instanceMetaField.getSystemName(), rootEntityIdentifier);
                                            return entity;
                                        }));
                                    }
                                    return of_1.of(entity);
                                }));
                            }
                        }
                        return of_1.of(entity);
                    }));
                }
                return of_1.of(entity);
            }));
        }
        return of_1.of(entity);
    };
    var DefaultModelDecoratorService_1;
    DefaultModelDecoratorService = DefaultModelDecoratorService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_de_service_client_js_1.DeService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_de_service_client_js_1.PortfolioService,
            idm_kb_service_client_js_1.KbService,
            idm_de_service_client_js_1.DePermissionService,
            type_configuration_service_1.TypeConfigurationService])
    ], DefaultModelDecoratorService);
    return DefaultModelDecoratorService;
}());
exports.DefaultModelDecoratorService = DefaultModelDecoratorService;
//# sourceMappingURL=default-model-decorator.service.js.map